import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface InternalDocumentByManager {
  name: string;
  api_token: string;
}

export interface InternalDocumentByManagerDetaiInfor {
  errors: unknown;
  InternalDocumentByManager: InternalDocumentByManager;
  isAuthenticated: boolean;
}

@Module
export default class InternalDocumentByManagerDetailModule
  extends VuexModule
  implements InternalDocumentByManagerDetaiInfor
{
  errors = {};
  InternalDocumentByManager = {} as InternalDocumentByManager;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get internalDocumentByManagerDetail() {
    return this.internalDocumentByManagerDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.INTERNAL_DOCUMENT_BY_MANAGER_DETAIL_DATA](
    InternalDocumentByManagerDetail
  ) {
    this.internalDocumentByManagerDetailData = InternalDocumentByManagerDetail;
  }

  @Action
  [Actions.INTERNAL_DOCUMENT_BY_MANAGER_DETAIL](payload) {
    return ApiService.getDataDetail(
      "/internal/vanbannoibo",
      payload,
      "detail",
      payload
    )
      .then(({ data }) => {
        this.context.commit(
          Mutations.INTERNAL_DOCUMENT_BY_MANAGER_DETAIL_DATA,
          data
        );
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
